import type { CanDeactivateFn } from '@angular/router';

/** Implemented by the capture screen, which {@link leaveCaptureGuard} protects. */
export interface ConfirmsLeavingCapture {
  /**
   * What to ask before leaving, or null when nothing is at stake (no
   * demonstration held, or the screen is leaving on its own after a finish
   * or a discard).
   */
  leavePrompt(): string | null;
}

/**
 * Confirm before leaving an in-progress demonstration (P79).
 *
 * Leaving no longer loses it: the owner can resume from Demonstrations. But
 * the VM keeps running in the meantime, and after 15 min with nobody
 * connected the demonstration is discarded. So this says so rather than
 * blocking. A plain `confirm()`, matching `pendingChangesGuard`.
 */
export const leaveCaptureGuard: CanDeactivateFn<ConfirmsLeavingCapture> = (component) => {
  const prompt = component.leavePrompt();
  return prompt === null || confirm(prompt);
};
